// BasicInformation.jsformikServices

import React, { useEffect, useState } from "react";
import { Grid, MenuItem, Button , Typography } from "@mui/material";
import useStyles from "./style";

import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";
import _ from "lodash";

//Api
import servicesApi from "../../../../../Services/Service";
import driverApi from "../../../../../Services/Driver";
import subcmpnysApi from "../../../../../Services/Subcompany";
import fileUploadApi from "../../../../../Services/ImageUpload";

//Chip

import { useTheme } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


function getStyles(name, allowedTypes, theme) {
  return {
    fontWeight:
      allowedTypes.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const Services = ({ onRef, formikServices , driverId , setsubmitButton , setSkipButton }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [vehicleImagePreview, setVehicleImagePreview] = useState("");
  const theme = useTheme();

 useEffect(() => {
  setsubmitButton(true);
  setSkipButton(true);
}, []);

  
    const getFormData = () => {
  return formikServices.values;
};
  

  useEffect(() => {
    onRef && onRef(getFormData);
  }, [onRef, getFormData]);

  const handleLicenseExpiryDate = (newValue) => {
    if (newValue === null || newValue === "") {
      formikServices.setFieldValue("licenseExpiryDate", newValue);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formikServices.setFieldValue("licenseExpiryDate", formattedDate);
    }
  };

  const handleInsuranceExpiryDate = (newValue) => {
    if (newValue === null || newValue === "") {
      formikServices.setFieldValue("insuranceExpiryDate", null);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formikServices.setFieldValue("insuranceExpiryDate", formattedDate);
    }
  };

  // Get Services

  const [servicesData, setServicesData] = useState([]);

  const getAllServices = () => {
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setServicesData(res?.data?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    servicesApi.getServiceswithfaremodel().then(onSuccess, onFailure);
  };

  useEffect(() => {
    getAllServices();
  }, []);

  // Get Subcompanies

  const [subcompaniesData, setSubcompaniesData] = useState([]);

  const getAllSubcompanies = () => {
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
      //  console.log('subcompanies data-->',res?.data?.data);
        setSubcompaniesData(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    subcmpnysApi.getallsubcmpniesnamelist().then(onSuccess, onFailure);
  };

  useEffect(() => {
    getAllSubcompanies();
  }, []);

  // Proceed allowed types
  const [allowedTypesName, setAllowedTypeNames] = useState([]);

  useEffect(() => {
    if (servicesData?.length) {
      const typeOptions = servicesData.map((service) => ({
        label: service.serviceName, // UI display value
        value: service._id, // Actual value (_id)
      }));
      setAllowedTypeNames(typeOptions);
    }
  }, [servicesData]);

 const handleAllowTypes = (_, values) => {
  const selectedIds = values.map((option) => option.value); // Extract _id values
  formikServices.setFieldValue("allowedTypes", selectedIds);
};

// get driver service details

  const [driverServiceData, setDriverServiceData] = useState([]);

  const driverServiceDetailsGet = () => {
    dispatch(showLoader("Loading please wait..."));

    let validation = true;

    if (driverId === "" || driverId === undefined) {
      validation = false;
      dispatch(
        showSnackbar({
          message: "Create a driver first",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "warning",
        })
      );
      dispatch(hideLoader());
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        //console.log('driver ride model --->',res?.data?.data);
        setDriverServiceData(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch driver's service details",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    if (validation) {
      driverApi.getDriverServiceDetails(driverId).then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    driverServiceDetailsGet();
  }, [driverId]);

const [formLoaded, setFormLoaded] = useState(false);

useEffect(() => {
  if (!_.isEmpty(driverServiceData) && !formLoaded) {
    formikServices.setValues({
      service: driverServiceData?.serviceTypeId || "",
      serviceType: driverServiceData?.serviceKind || "",
      subcompanyname: driverServiceData?.sub_companyName || "",
      vehicleNumber: driverServiceData?.vehicleNumber || "",
      vehicleModel: driverServiceData?.vehicleModel || "",
      driverLicenseNumber: driverServiceData?.driverLicenseNumber || "",
      licenseExpiryDate: driverServiceData?.licenseExpiryDate || "",
      vehicleInsuranceNumber: driverServiceData?.vehicleInsuranceNumber || "",
      insuranceExpiryDate: driverServiceData?.insuranceExpiryDate || "",
      allowedTypes: driverServiceData?.allowedTypes || [],
      vehicleColour: driverServiceData?.vehicleColour || "",
      vehicleimage: driverServiceData?.vehicleimage || ""
    });

    setFormLoaded(true); // 🔒 prevent overwrite
  }
}, [driverServiceData, formLoaded]);


// Drop zone and upload the image of the car   

  const uploadProfileImage = (acceptedFiles) => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Vehicle image uploaded successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        //console.log("res.data--->",res?.data?.data)
            // formikServices.resetForm();
            // driverServiceDetailsGet();
        // setVehicleImagePreview(res?.data?.data?.vehicleimage);
        formikServices.setFieldValue("vehicleimage", res?.data?.data?.vehicleimage);
     //   setVehicleImagePreview(res?.data?.data?.vehicleimage);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      showSnackbar({
        message: err?.data?.msg || "Error while upload image",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      //console.log("profile image upload api", err);
    };
    const formData = new FormData();
    //console.log("acceptedFiles-->",acceptedFiles);
    // acceptedFiles?.map((file) => formData.append("file", file));
    acceptedFiles.forEach((file) => {
      formData.append("image", file); // Append the file
    });
    formData.append("userId", driverId); // Append the userId to FormData
    
    fileUploadApi.carimageupload(formData).then(onSuccess, onFailure);
  };
  // Max file size
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  // File length validator
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };
  // Dropzone props
  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: maxFileSize, // Use raw maxFileSize, not formatted value
    maxFiles: 1,
    accept: "image/*", // Valid MIME types
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      let fileLength = acceptedFiles.map((file) => file.size);
if (acceptedFiles && acceptedFiles[0]?.size < maxFileSize) {
        uploadProfileImage(acceptedFiles);
      }
    },
  });

  return (
    <div className={classes.BasicInformationStyles}>
      <Grid container>
        <section className={classes.container}>
          <Grid item xs={12} className={classes.detailsContainer}>
            <Grid container className={classes.containerWrapper}>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.textFieldWrapper}
                  >
<TextField
name="service"
id="service"
select
label="service"
value={formikServices?.values?.service || ""}
onChange={formikServices?.handleChange}
error={
formikServices?.errors?.service &&
formikServices?.touched?.service
}
helperText={
formikServices?.errors?.service &&
formikServices?.touched?.service &&
formikServices?.errors?.service
}
fullWidth
variant="outlined"
size="small"
>
{servicesData.map((services) => (
<MenuItem key={services._id} value={services._id}>
  {services.serviceName}
</MenuItem>
))}
</TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                  >
<Grid container>
<Grid item md={6} lg={6} xl={6} className={classes.textFieldWrapper} >
<TextField
name="serviceType"
id="serviceType"
select
label="Service Type"
value={formikServices?.values?.serviceType || "" }
onChange={formikServices?.handleChange}
error={
formikServices?.errors?.serviceType &&
formikServices?.touched?.serviceType
}
helperText={
formikServices?.errors?.serviceType &&
formikServices?.touched?.serviceType &&
formikServices?.errors?.serviceType
}
fullWidth
variant="outlined"
size="small"
>
<MenuItem value="OWN_SERVICE">Own Service</MenuItem>
<MenuItem value="ATTACHED_SERVICE">
Attached Service
</MenuItem>
</TextField>
</Grid>
<Grid item md={6} lg={6} xl={6} className={classes.textFieldWrapper} >
<TextField
name="subcompanyname"
id="subcompanyname"
select
label="Sub-company"
value={formikServices?.values?.subcompanyname || ""}
onChange={formikServices?.handleChange}
error={
formikServices?.errors?.subcompanyname &&
formikServices?.touched?.subcompanyname
}
helperText={
formikServices?.errors?.subcompanyname &&
formikServices?.touched?.subcompanyname &&
formikServices?.errors?.subcompanyname
}
fullWidth
variant="outlined"
size="small"
disabled={formikServices?.values?.serviceType !== "ATTACHED_SERVICE"}
>
{subcompaniesData.map((companies) => (
<MenuItem key={companies._id} value={companies.companyName}>
  {companies.companyName}
</MenuItem>
))}
</TextField>
</Grid>
</Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.textFieldWrapper}
                  >
<Autocomplete
  multiple
  id="allowedTypes"
  name="allowedTypes"
  options={allowedTypesName} // Options contain label and value
  getOptionLabel={(option) => option.label} // Display label
  value={
    allowedTypesName.filter((option) =>
      formikServices?.values?.allowedTypes?.includes(option.value)
    ) || []
  }
  onChange={handleAllowTypes}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Allowed Types"
      variant="outlined"
      size="small"
      style={{ width: "100%" }}
      error={
        formikServices?.errors?.allowedTypes &&
        formikServices?.touched?.allowedTypes
      }
      helperText={
        formikServices?.errors?.allowedTypes &&
        formikServices?.touched?.allowedTypes &&
        formikServices?.errors?.allowedTypes
      }
    />
  )}
  renderTags={(value, getTagProps) => (
    <Box>
      {value.map((option, index) => (
        <Chip
          key={index}
          label={option.label} // Show the serviceName as chip
          {...getTagProps({ index })}
        />
      ))}
    </Box>
  )}
/>

                  </Grid>

<Grid item xs={12}md={12}lg={12}xl={12} >
<Grid container>
<Grid item md={6} lg={6} xl={6} className={classes.textFieldWrapper} >
<TextField
name="vehicleNumber"
id="vehicleNumber"
label="Vehicle Number"
value={formikServices?.values?.vehicleNumber || "" }
onChange={formikServices?.handleChange}
error={
  formikServices?.errors?.vehicleNumber &&
  formikServices?.touched?.vehicleNumber
}
helperText={
  formikServices?.errors?.vehicleNumber &&
  formikServices?.touched?.vehicleNumber &&
  formikServices?.errors?.vehicleNumber
}
fullWidth
variant="outlined"
size="small"
/>
</Grid>
<Grid item md={6} lg={6} xl={6} className={classes.textFieldWrapper} >
<TextField
                      name="vehicleModel"
                      id="vehicleModel"
                      label="Vehicle Model"
                      value={formikServices?.values?.vehicleModel || "" }
                      onChange={formikServices?.handleChange}
                      error={
                        formikServices?.errors?.vehicleModel &&
                        formikServices?.touched?.vehicleModel
                      }
                      helperText={
                        formikServices?.errors?.vehicleModel &&
                        formikServices?.touched?.vehicleModel &&
                        formikServices?.errors?.vehicleModel
                      }
                      fullWidth
                      variant="outlined"
                      size="small"
                    />
</Grid>
</Grid>

                  </Grid>

<Grid item xs={12}md={12}lg={12}xl={12} >
<Grid container>
<Grid item md={12} lg={12} xl={12} className={classes.textFieldWrapper} >
<TextField
name="vehicleColour"
id="vehicleColour"
label="Vehicle Colour"
value={formikServices?.values?.vehicleColour || "" }
onChange={formikServices?.handleChange}
error={
  formikServices?.errors?.vehicleColour &&
  formikServices?.touched?.vehicleColour
}
helperText={
  formikServices?.errors?.vehicleColour &&
  formikServices?.touched?.vehicleColour &&
  formikServices?.errors?.vehicleColour
}
fullWidth
variant="outlined"
size="small"
/>
</Grid>
</Grid>

                  </Grid>


                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
              <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.textFieldWrapper}
                  >
                    <TextField
                      name="driverLicenseNumber"
                      id="driverLicenseNumber"
                      label="Driver License Number"
                      value={formikServices?.values?.driverLicenseNumber || "" }
                      onChange={formikServices?.handleChange}
                      error={
                        formikServices?.errors?.driverLicenseNumber &&
                        formikServices?.touched?.driverLicenseNumber
                      }
                      helperText={
                        formikServices?.errors?.driverLicenseNumber &&
                        formikServices?.touched?.driverLicenseNumber &&
                        formikServices?.errors?.driverLicenseNumber
                      }
                      fullWidth
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.textFieldWrapper}
                >
                  <div className={classes.datePickerStyle}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="License Expiry Date"
                        value={formikServices?.values?.licenseExpiryDate || ""}
                        size="small"
                        onChange={(newValue) => {
                          handleLicenseExpiryDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={
                              formikServices?.errors?.licenseExpiryDate &&
                              formikServices?.touched?.licenseExpiryDate
                            }
                            helperText={
                              formikServices?.errors?.licenseExpiryDate &&
                              formikServices?.touched?.licenseExpiryDate &&
                              formikServices?.errors?.licenseExpiryDate
                            }
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.textFieldWrapper}
                >
                  <TextField
                    name="vehicleInsuranceNumber"
                    id="vehicleInsuranceNumber"
                    label="Vehicle Insurance Number"
                    value={formikServices?.values?.vehicleInsuranceNumber || "" }
                    onChange={formikServices?.handleChange}
                    error={
                      formikServices?.errors?.vehicleInsuranceNumber &&
                      formikServices?.touched?.vehicleInsuranceNumber
                    }
                    helperText={
                      formikServices?.errors?.vehicleInsuranceNumber &&
                      formikServices?.touched?.vehicleInsuranceNumber &&
                      formikServices?.errors?.vehicleInsuranceNumber
                    }
                    fullWidth
                    variant="outlined"
                    size="small"
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.textFieldWrapper}
                >
                  <div className={classes.datePickerStyle}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Insurance Expiry Date"
                        value={formikServices?.values?.insuranceExpiryDate || ""}
                        size="small"
                        onChange={(newValue) => {
                          handleInsuranceExpiryDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={
                              formikServices?.errors?.insuranceExpiryDate &&
                              formikServices?.touched?.insuranceExpiryDate
                            }
                            helperText={
                              formikServices?.errors?.insuranceExpiryDate &&
                              formikServices?.touched?.insuranceExpiryDate &&
                              formikServices?.errors?.insuranceExpiryDate
                            }
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </Grid>
                
               <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.textFieldWrapper}
                >
<Typography variant="subtitle1" sx={{ mb: 1 }}>
Vehicle Image
</Typography>
          <section className={classes.avatarContainer}>

            <div className={classes.avatarWrapper}>
              <div className={classes.avatar}>
                <img
                key={vehicleImagePreview}
                  src={
                  vehicleImagePreview
                  ? vehicleImagePreview
                   : !_.isEmpty(formikServices?.values?.vehicleimage)
                      ? `${formikServices?.values?.vehicleimage}`
                      : "/assets/images/logos/no-image.png"
                  }
                  alt="avatar"
                  className={classes.img}
                />
                <section
                  {...getRootProps()}
                  onClick={open}
                  className={classes.editIcon}
                >
                  <input  {...getInputProps()} />
                  <CameraAltOutlinedIcon />
                </section>
              </div>
            </div>
          </section>
        </Grid>


              </Grid>
            </Grid>
          </Grid>
        </section>
      </Grid>
    </div>
  );
};

export default Services;
